/* TODO: update according to reality */

import translate from "src/functions/translate";

function optionsChannel(lang: string) {
  return [
    { title: translate(`any`, lang), value: `any` },
    { title: translate(`facebook stream`, lang), value: `facebook_stream` },
    { title: translate(`google meet`, lang), value: `google_meet` },
    { title: translate(`instagram`, lang), value: `instagram` },
    { title: translate(`microsoft teams`, lang), value: `microsoft_teams` },
    { title: translate(`zoom`, lang), value: `zoom` },
  ];
}

export default optionsChannel;
